import { useState } from 'react';

import { Button, Modal } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { TFundingRequirementsSteps } from '../orderFundingRequirements';
import StepItem from '../stepItem/StepItem';
import { CommissionConsentModal } from './commissionConsentModal/CommissionConsentModal';
import { FormalOffer } from '../../../myOffers/MyOffers.types';

export const CommissionConsentAction = ({
    status,
    formalOffer,
    triggerRefetchFundingRequirements
}: {
    status: TFundingRequirementsSteps['0']['status'];
    formalOffer: FormalOffer;
    triggerRefetchFundingRequirements: () => void;
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    function onConfirm() {
        triggerRefetchFundingRequirements();
        setIsModalOpen(false);
    }

    return (
        <>
            <StepItem
                title={
                    <FormattedMessage
                        id="_.funding_requirements.commission_consent_title"
                        defaultMessage="Introducer Commission"
                    />
                }
                caption={
                    <FormattedMessage
                        id="_.funding_requirements.commission_consent_caption"
                        defaultMessage="View and agree the commission paid to your introducer by iwoca."
                    />
                }
                action={
                    status === 'COMPLETED' ? (
                        <Button
                            variant="secondary"
                            onClick={() => setIsModalOpen(true)}
                        >
                            <FormattedMessage
                                id="_.funding_requirements.commission_consent_completed_action"
                                defaultMessage="View"
                            />
                        </Button>
                    ) : (
                        <Button
                            variant="primary"
                            onClick={() => setIsModalOpen(true)}
                            data-testId="commission-consent-action-button"
                        >
                            <FormattedMessage
                                id="_.funding_requirements.commission_consent_action"
                                defaultMessage="View & Agree"
                            />
                        </Button>
                    )
                }
            />

            <Modal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                closeIcon
            >
                <CommissionConsentModal
                    formalOffer={formalOffer}
                    isReadOnly={status === 'COMPLETED'}
                    onConfirm={onConfirm}
                />
            </Modal>
        </>
    );
};
